import React from "react";
import PropTypes from "prop-types";

/* One chevron, rotated. Rotation rather than four separate polylines because
   consumers toggle `direction` on expand/collapse and animate the turn with
   `transition: transform` — swapping the path instead would snap. */
const ROTATION = {
    right: "rotate(0deg)",
    down: "rotate(90deg)",
    left: "rotate(180deg)",
    up: "rotate(270deg)",
};

/* Explicit width/height: WebKit mis-sizes a viewBox-only inline SVG even when
   CSS sets it to 100%, which pushes the chevron off-centre. Pass `size` to fix
   the box, or let a consumer's CSS override the 24px intrinsic default. */
export default function ChevronIcon({ direction = "right", size = 24, style, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            style={{ transform: ROTATION[direction] || ROTATION.right, ...style }}
            {...props}
        >
            <polyline points="9 6 15 12 9 18" />
        </svg>
    );
}

ChevronIcon.propTypes = {
    direction: PropTypes.oneOf(["left", "right", "up", "down"]),
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.object,
};
